import { createContext } from 'react';
import type { HttpProblem } from '../api/generated/client';

export interface BannerContextType {
    show: (problem: HttpProblem) => void;
    clear: () => void;
}

export const BannerContext = createContext<BannerContextType | undefined>(undefined);
